import _ from 'lodash';

const checkIsFlightInputsChanged = ({ searchInputs, compareBase }) => {
  if (
    typeof compareBase === 'object' &&
    Object.keys(compareBase || {}).length > 0 &&
    typeof searchInputs === 'object' &&
    Object.keys(searchInputs || {}).length > 0 &&
    searchInputs.flightSegments &&
    searchInputs.flightSegments.length &&
    compareBase.flightSegments &&
    compareBase.flightSegments.length
  ) {
    return (
      JSON.stringify(compareBase.flightSegments) !== JSON.stringify(searchInputs.flightSegments) ||
      JSON.stringify(compareBase.staterooms) !== JSON.stringify(searchInputs.staterooms) ||
      (searchInputs.doShowRefundableFlightsOnly || false) !==
        (compareBase.doShowRefundableFlightsOnly || false) ||
      (searchInputs.doShowLongConnectFlights || false) !==
        (compareBase.doShowLongConnectFlights || false) ||
      (searchInputs.doHideNdcFares || false) !== (compareBase.doHideNdcFares || false) ||
      (searchInputs.doEnableFlightsPolling || false) !==
        (compareBase.doEnableFlightsPolling || false) ||
      (searchInputs.exactMatchRateCodesOnly || false) !==
        (compareBase.exactMatchRateCodesOnly || false) ||
      searchInputs.maxNumOfStops !== compareBase.maxNumOfStops ||
      (searchInputs.keepSameCabin || false) !== compareBase.keepSameCabin ||
      (searchInputs.avoidCabinDowngrade || false) !== compareBase.avoidCabinDowngrade ||
      JSON.stringify(_.orderBy(_.map(searchInputs.airlines || [], 'value'))) !==
        JSON.stringify(_.orderBy(_.map(compareBase.airlines || [], 'value'))) ||
      JSON.stringify(_.orderBy(searchInputs.rateCodes || [])) !==
        JSON.stringify(_.orderBy(compareBase.rateCodes || [])) ||
      (searchInputs.doExcludeAirportChanges || false) !==
        (compareBase.doExcludeAirportChanges || false)
    );
  }
  return false;
};

export default checkIsFlightInputsChanged;
